export default "__VITE_PUBLIC_ASSET__edc21230__"